export default __webpack_public_path__ + "static/media/IconTick.55ce9c0c.svg";